import Config from '@annunciate/core/dist/utils/config';
import { FINALIZE_PURCHASE } from '@annunciate/query/dist/queries/purchase';
import { useMutation } from './base';
export const useFinalizePurchaseMutation = () => {
    return useMutation(FINALIZE_PURCHASE, {}, (data) => data.finalizePurchase, Config.ENTITLEMENTS_HOST);
};
//# sourceMappingURL=useFinalizePurchaseMutation.js.map